import React, { Component } from 'react';
import PropTypes from 'prop-types';
import OrderbookContainerTutorial from './OrderbookContainerTutorial'
import TransactionSwitcherTutorial from './TransactionSwitcherTutorial';
import TotalStatsTutorial from './TotalStatsTutorial.js';
import SwitcherTutorial from './SwitcherTutorial';
import '../../style/Orderbook.css';
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
//import * as firebase from 'firebase';
import 'intro.js/introjs.css';
import { Steps } from 'intro.js-react';


//This component acts as the container for
//all components of the simulation receives
//user prop from app.js

class ContainerTutorial extends Component {
  constructor(props) {
    super(props);
    this.state = {
      renderplotly: true,
      stepsEnabled: false,
      initialStep: 0,
      steps: [
        {
          element: '#orderbook_test',
          intro: 'This is the orderbook of the simulation. This is where you see and place orders throughout the game',
        },
        {
          element: '.marketBuy',
          intro: 'Here you can make a market buy order',
        },
        {
          element: '.start',
          intro: 'Here is where you can start a simulation that you created',
        },
        {
          element: '.marketSell',
          intro: 'Here you can make a market sell order'
        },
        {
          element: '.bidInput',
          intro: 'Here you can place and cancel your limit bid orders'
        },
        {
          element: '.bid',
          intro: 'Here are the current bids at a given strike price'
        },
        {
          element: '.strike',
          intro: 'Here you will see all of the available strikes in the orderbook'
        },
        {
          element: '.ask',
          intro: 'Here are the current asks at a given strike price'
        },
        {
          element: '.askInput',
          intro: 'Here you can place and cancel your limit ask orders'
        },
        {
          element: '#assets',
          intro: 'Here is where you can keep track of both yours and the markets stats',
        },
        {
          element: '.cash',
          intro: 'Here is where you see your current cash',
        },
        {
          element: '.shares',
          intro: 'Here is where you see how many shares you currently hold',
        },
        {
          element: '.avgbuy',
          intro: 'Here is where you can see the average price you bought at',
        },
        {
          element: '.avgsell',
          intro: 'Here is where you can see the average price you sold at',
        },
        {
          element: '.pl',
          intro: 'Here is where you can keep track of youre profit or loss',
        },
        {
          element: '.marketVwap',
          intro: 'Here is where you can see the average price the market is trading at',
        },
        {
          element: '.LastPrice',
          intro: 'Here is where you can see the last price an asset was traded at',
        },
        {
          element: '.TotalVol',
          intro: 'Here is where you can see the total volume traded of the market',
        },
        {
          element: '.ThisPosition',
          intro: 'Here is where you can keep track of your current average buy/sell price since youve crossed 0',
        },
        {
          element: '.mission',
          intro: 'Here is where you can see what your objective is for the simulation',
        },
        {
          element: '#plotly-div',
          intro: 'Here you can see nice candlestick and line graphs of the days trading, includeing a 3 day simulation prior to the start of the simulation'
        },
        {
          element: '#transactions',
          intro: 'Here you can switch between user and market transactions made during the simulation'
        }
      ]
    };
    this.startTutorial = this.startTutorial.bind(this);
  }

  componentDidMount() {
    //goes to ref StartSim/Ready and
    //sets the state of renderplotly
  //   this.plotlyrenderRef = firebase.database().ref().child("Session2").child('StartSim').child("Ready");
  //   this.plotlyrenderRef.on('value', snap => {
  //     if (!!snap.val() & snap.val() === true) {
  //       this.setState({
  //         renderplotly: true
  //       });
  //     } else {
  //       this.setState({
  //         renderplotly: false
  //       });
  //     }
  //   })
   }

  startTutorial(){
    this.setState({
      stepsEnabled:true
    })
  }



  // componentWillUnmount() {
  //   this.plotlyrenderRef.off();
  // }

  render() {
    const { stepsEnabled, steps, initialStep } = this.state;
    //renders all components of the simulation here
    return (
      <div className="container">
        <Steps
          enabled={stepsEnabled}
          steps={steps}
          initialStep={initialStep}
          onExit={function(){}}
        />
        <div className="row">
          <button style={{'margin':'5px'}} onClick={this.startTutorial} className="btn btn-primary">Start Tutorial</button>
        </div>
        <div className="row">
            <div id="orderbook_test" className="col-xs-12 col-lg-5">
                <OrderbookContainerTutorial institution={this.props.institution} uid={this.props.user.uid} />
            </div>
            <div className='col-xs-12 col-lg-7'>
            <div id="assets" className="row">
              <TotalStatsTutorial institution={this.props.institution}  uid={this.props.user.uid} />
            </div>
            <div className='row'>
              {this.state.renderplotly
                //based on renderplotly(bool) conditionally
                //render plotly graph
              ?<div className='col-xs-12 col-lg-12' id="plotly-div">
                <SwitcherTutorial institution={this.props.institution} />
              </div>
              :<div style={{'textAlign':'center', 'marginTop':'150px','fontSize':'26px'}}>Loading 3 Day Sim...</div>
            }
            </div>
          </div>
        </div>
        <div className="row">
            <div className="col-xs-12 col-lg-12" id="transactions">
              <TransactionSwitcherTutorial institution={this.props.institution} uid={this.props.user.uid} />
            </div>
        </div>
      </div>
    );
  }
}

ContainerTutorial.propTypes = {
  authed: PropTypes.bool,
  user: PropTypes.object,
  sessionid: PropTypes.string
};

export default ContainerTutorial;



// WEBPACK FOOTER //
// ./src/components/OrderbookTutorial/ContainerTutorial.js